const CABECERA = 'CAB'
const PIEPAGINA = 'PPA'

const __dictionary = {
  [CABECERA]: {
    id: CABECERA,
    nombre: 'CABECERA'
  },
  [PIEPAGINA]: {
    id: PIEPAGINA,
    nombre: 'PIE DE PAGINA'
  }
}

const __array = [__dictionary[CABECERA], __dictionary[PIEPAGINA]]

const __vaues = [CABECERA, PIEPAGINA]

export default Object.freeze({
  CABECERA,
  PIEPAGINA,
  __dictionary,
  __array,
  __vaues
})
